import { lazy, Suspense } from 'react';

import { ListSkeleton } from '@/shared/components/skeletons';
import { Skeleton } from '@/shared/ui/skeleton';

/*
 * The heavy parts of the module (card, boards, Gantt) load on demand; these wrappers are what the registry renders.
 */

const TaskPanel = lazy(() => import('./components/panel/TaskPanel'));
const GroupTasksTab = lazy(async () => ({ default: (await import('./components/tabs')).GroupTasksTab }));
const ProfileTasksTab = lazy(async () => ({ default: (await import('./components/tabs')).ProfileTasksTab }));
const LinkedTasksTab = lazy(async () => ({ default: (await import('./components/tabs')).LinkedTasksTab }));

function PanelFallback() {
  return (
    <div className="space-y-4 p-6" aria-busy>
      <Skeleton className="h-6 w-2/3" />
      <Skeleton className="h-4 w-40" />
      <ListSkeleton rows={4} avatar={false} />
    </div>
  );
}

export function LazyTaskPanel({ id }: { id: string }) {
  return (
    <Suspense fallback={<PanelFallback />}>
      <TaskPanel id={id} />
    </Suspense>
  );
}

export function LazyGroupTasksTab({ groupId }: { groupId: string }) {
  return (
    <Suspense fallback={<ListSkeleton rows={5} />}>
      <GroupTasksTab groupId={groupId} />
    </Suspense>
  );
}

export function LazyProfileTasksTab({ userId }: { userId: string }) {
  return (
    <Suspense fallback={<ListSkeleton rows={4} />}>
      <ProfileTasksTab userId={userId} />
    </Suspense>
  );
}

export function LazyLinkedTasksTab({ module, type, id }: { module: string; type: string; id: string }) {
  return (
    <Suspense fallback={<ListSkeleton rows={3} />}>
      <LinkedTasksTab module={module} type={type} id={id} />
    </Suspense>
  );
}
